export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex flex-col justify-center overflow-hidden" aria-labelledby="hero-title">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20soft%20ambient%20gradient%20in%20muted%20sage%20green%20and%20pale%20warm%20stone%20tones%2C%20smooth%20organic%20color%20transitions%20with%20no%20sharp%20edges%2C%20minimalist%20atmospheric%20texture%2C%20no%20objects%20no%20people%20no%20text%2C%20ethereal%20and%20airy%20composition%2C%20fine%20art%20quality%2C%20delicate%20tonal%20washes%20with%20subtle%20depth%2C%20light-filled%20and%20spacious%20feeling&width=1800&height=1200&seq=hero-bg-bruny-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-transparent to-black/5"></div>
      </div>

      <div className="relative z-10 w-full px-8 md:px-16 lg:px-24 pt-32 pb-20">
        <div className="max-w-7xl">
          <h1 id="hero-title" className="font-heading text-5xl md:text-7xl lg:text-8xl font-bold text-foreground-950 leading-[1.1] tracking-tight">
            Bruny Digital AB
          </h1>
          <p className="font-heading text-3xl md:text-5xl lg:text-6xl font-light text-foreground-700 leading-[1.15] mt-3 tracking-tight">
            Engineering the future
          </p>
          <p className="font-heading text-3xl md:text-5xl lg:text-6xl font-light text-foreground-600 leading-[1.15] tracking-tight">
            of digital software
          </p>
        </div>

        <div className="max-w-7xl mt-32 md:mt-40 lg:mt-48 flex flex-col lg:flex-row gap-20 lg:gap-32">
          <div className="lg:w-[35%]">
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
              A professional engineering team dedicated to designing and developing modern digital software solutions for the iOS platform and related technologies. We build systems that are as elegant as they are resilient.
            </p>
          </div>
          <div className="lg:w-[35%] lg:mt-8">
            <p className="text-base md:text-lg text-foreground-700 leading-relaxed">
              Our work is grounded in clean architecture, performance optimization, and user-centered design &mdash; principles that ensure every project we deliver stands the test of time and scale.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}